// extracted by mini-css-extract-plugin
module.exports = {"parts-diagram":"parts-diagram_parts-diagram__9Wdbi","dragging":"parts-diagram_dragging__3oekO"};